import React from 'react';

const FORMATTED_ROW_NAMES = {
	First: '1st',
	Second: '2nd',
	Third: '3rd',
	Fourth: '4th',
};

export const RowNumberColumn = React.forwardRef(function RowNumberColumn(
	{ row, isLastRowVendor },
	ref,
) {
	if (!row) return '';

	return (
		<span ref={ref}>
			{FORMATTED_ROW_NAMES[row] || ''}
			<br /> Row
		</span>
	);
});
